<template>
  <CmLineSidebar class="contactCenter-entity-default-info client-info">
    <h4 class="cm-title">{{ $t('contactCenter.sections.personalInfo') }}</h4>
    <div class="contactCenter-entity-default-info__data client-info__general" v-if="info">
      <div v-for="(item, index) in personalData" :key="index" class="client-info__general-row">
        <img
          :src="require(`@/assets/images/clients/${item.icon}.svg`)"
          :alt="item.icon"
        />
        <span class="client-info__general-row-title">
          {{ $t(`contactCenter.form.${item.name}`) }}:
        </span>
        <span :class="[
          item.name === 'EMailAddress1' || item.name === 'MobilePhone' ? 'client-info__general-row-link' : 'client-info__general-row-value',
          info.attributes[item.confirmed] ? 'client-info__general-row-link--confirmed' : '',
          info.attributes[item.name] === null ? 'client-info__general-row--not-found' : ''
        ]">
          {{ parseValue(info.attributes[item.name], item.name) }}
        </span>
      </div>
    </div>

    <div v-if="sections !== []" v-for="(section) in sections" class="contactCenter-entity-default-info__section">
      <h4 class="cm-title">{{ $t(`contactCenter.sections.${section.title}`) }}</h4>
      <div v-for="(item, index) in section.content" :key="index + item">
        <Field :config="attributes[item]"
              v-model="values[item]"
              :isEditMode="false"/>
      </div>
    </div>

  </CmLineSidebar>
</template>

<script>
import CmLineSidebar from "@/components/library/CmLineSidebar.vue";
import ColorTags from "@/components/ColorTags.vue";
import {mapState} from "vuex";
import contactCenterService from "@/services/ContactCenterService";
import Field from "../../../../components/field/Index.vue";

import data from "@/mockData/clientInfo.json";

export default {
  name: "contactCenterEntityInfoClients",

  components: {
    Field,
    ColorTags,
    CmLineSidebar
  },

  data() {
    return {
      personalData: [
        {
          name: 'MobilePhone',
          icon: 'phone',
          confirmed: 'HasVerifiedMobile'
        },
        {
          name: 'EMailAddress1',
          icon: 'email',
          confirmed: 'HasVerifiedEMail'
        },
        {
          name: 'AllowSmsSending',
          icon: 'checked-square'
        },
        {
          name: 'AllowEMailSending',
          icon: 'checked-square',
        },
        {
          name: 'Birthday',
          icon: 'birthday'
        },
        {
          name: 'LevelId',
          icon: 'level'
        },
      ],
      sections: [
        // {
        //   "title": "purchases",
        //   "content": ["Sum", "AllDiscountedSum", "SumAfterDiscounted", "Discount", "Quantity", "AverageCheque", "AverageChequeAfterDiscounted", "LastTransactionOn"]
        // },
        // {
        //   "title": "bonusBalance",
        //   "content": ["Debet", "Credit", "Balance", "ActiveBalance"]
        // },
        // {
        //   "title": "statusBonusBalance",
        //   "content": ["StatusDebet", "StatusCredit", "StatusBalance", "StatusActiveBalance"]
        // },
        // {
        //   "title": "moneyBalance",
        //   "content": ["MoneyDebet", "MoneyCredit", "MoneyBalance"]
        // }
      ],
      attributes: [],
      values: []
    }
  },
  computed: {
    ...mapState({
      info: state => state.contactCenter.info,
    }),

    client() {
      return data.info;
    },
  },

  mounted() {
    this.getSectionsInfo();
  },

  methods: {
    parseValue(item, index) {
      if (item === null) return this.$t("contactCenter.info.notFound");
      if (index === 'Birthday') return this.$dayjs(item).format('DD.MM.YYYY');
      if (index === 'LevelId') return item ? item.label : item;
      return (index === "AllowSmsSending" || index === "AllowEMailSending") ? this.parseBool(item) : item
    },

    parseBool(code) {
      return code ? this.$t("contactCenter.info.allow") : this.$t("contactCenter.info.notAllow");
    },

    async getSectionsInfo() {
      try {
        const {id} = this.$route.params;
        const contactBalance = await contactCenterService.getRelationships('Contact', id, 'ContactBalance', 'ContactId', 0, '')
        this.values = contactBalance[0].attributes
        const metaData = await contactCenterService.getEntityMetaData('ContactBalance');
        this.attributes = metaData.attributes

        this.sections.forEach(section => {
          section.content.forEach(field => {
            this.$set(this.attributes, field, {
              ...this.attributes[field],
              label: "ContactBalance" + field
            });
          })
        })
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.contactCenter-entity-default-info {
  padding: 15px 0 15px 20px;
  width: 490px;

  &__data {
    padding-right: 45px;

    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }

  &__section {
    margin-top: 30px;
  }

  .cm-line-sidebar__title {
    transform: rotate(270deg) translate(-80px, -45px);
  }

  .cm-title {
    margin-top: 0;
    margin-bottom: 23px;
  }

  &.cm-line-sidebar--closed {
    padding: 0;
  }
}

.client-info {
  &__general {
    &-row {
      &:not(:last-of-type) {
        padding-bottom: 10px;
      }

      &-title {
        &:before {
          padding-right: 5px;
        }
      }

      &-value {
        color: rgba($color: #000000, $alpha: 0.9);
        font-weight: 600;
      }

      &-link {
        border-bottom: 1px solid $color_gray_b1;
        color: $color_green-new;
        font-weight: 600;
        white-space: nowrap;

        &--confirmed {
          position: relative;
          &:after {
            position: absolute;
            content: url('#{$image-path}clients/checked-circle.svg');
            top: -3px;
            right: -15px;
          }
        }
      }

      &--not-found {
        font-size: 14px;
        font-weight: 400 !important;
        color: $color_disabled;
        border: none;
        opacity: 0.4;
      }
    }
  }

  &__segments-item {
    margin-bottom: 10px;
  }

  &__offers {
    &-row {
      padding-bottom: 7px;
    }

    &-link {
      color: $color_green-new;
      cursor: pointer;
      font-weight: 600;
    }
  }

  &__comments-text {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    padding: 15px;
    min-height: 175px;
  }
}
</style>
